module.exports = __webpack_public_path__ + "02_short_black.6447756d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/02_short_black.png
// module id = LmTI
// module chunks = 0